module.exports = __webpack_public_path__ + "static/media/icon_color.ef14ad99.svg";